import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Collapse } from '../../../cdl-react-components/components'
import Thumbnails from '../../Thumbnails'
import Link from '../../Link'

const articleSample = (props) => {
    const { sample } = props

    let href = ''
    if (sample.sample_article)
        href = '/article/' + sample.sample_article.id
    else if (sample.sample_activity_map)
        href = '/activityMap/' + sample.sample_activity_map.id
    else if (sample.sample_regional_map)
        href = '/map/' + sample.sample_regional_map.id

    return (
        <Collapse
            title={sample.title}
            className="article-sample__item">
            <div dangerouslySetInnerHTML={{ __html: sample.synopsis }} /><br />
            { sample.sample_article || sample.sample_activity_map || sample.sample_regional_map  ?
                (<Fragment>
                    { sample.sample_article && (<Thumbnails article={sample.sample_article} />) }
                    <Link href={href}>View a {sample.title} Sample</Link>
                </Fragment>) : null }
        </Collapse>
    )
}

articleSample.propTypes = {
    sample: PropTypes.object.isRequired
}

export default articleSample